import { createSlice, createAsyncThunk } from '@reduxjs/toolkit';
import api from '../../utils/api';

export const fetchPublicOfficials = createAsyncThunk(
  'publicOfficials/fetchAll',
  async (_, { rejectWithValue }) => {
    try {
      const res = await api.get('/public-officials');
      // Accept both array and { data: [...] }
      return Array.isArray(res.data) ? res.data : (res.data.data || []);
    } catch (err) {
      return rejectWithValue(err.response?.data?.error || 'Failed to fetch public officials');
    }
  }
);
// ... existing code ...

export const fetchPublicOfficialById = createAsyncThunk(
  'publicOfficials/fetchById',
  async (id, { rejectWithValue }) => {
    try {
      const res = await api.get(`/public-officials/${id}`);
      return res.data;
    } catch (err) {
      return rejectWithValue(err.response?.data?.error || 'Failed to fetch public official');
    }
  }
);

export const createPublicOfficial = createAsyncThunk(
  'publicOfficials/create',
  async (data, { rejectWithValue }) => {
    try {
      const res = await api.post('/public-officials', data);
      return res.data;
    } catch (err) {
      return rejectWithValue(err.response?.data?.error || 'Failed to create public official');
    }
  }
);

export const updatePublicOfficial = createAsyncThunk(
  'publicOfficials/update',
  async ({ id, ...data }, { rejectWithValue }) => {
    try {
      const res = await api.put(`/public-officials/${id}`, data);
      return res.data;
    } catch (err) {
      return rejectWithValue(err.response?.data?.error || 'Failed to update public official');
    }
  }
);

export const deletePublicOfficial = createAsyncThunk(
  'publicOfficials/delete',
  async (id, { rejectWithValue }) => {
    try {
      await api.delete(`/public-officials/${id}`);
      return id;
    } catch (err) {
      return rejectWithValue(err.response?.data?.error || 'Failed to delete public official');
    }
  }
);

const publicOfficialsSlice = createSlice({
  name: 'publicOfficials',
  initialState: {
    items: [],
    current: null,
    status: 'idle',
    error: null,
    createStatus: 'idle',
    createError: null,
    updateStatus: 'idle',
    updateError: null,
    deleteStatus: 'idle',
    deleteError: null,
  },
  reducers: {},
  extraReducers: (builder) => {
    builder
      .addCase(fetchPublicOfficials.pending, (state) => {
        state.status = 'loading';
      })
      .addCase(fetchPublicOfficials.fulfilled, (state, action) => {
        state.status = 'succeeded';
        state.items = action.payload || [];
      })
      .addCase(fetchPublicOfficials.rejected, (state, action) => {
        state.status = 'failed';
        state.error = action.payload;
      })
      .addCase(fetchPublicOfficialById.pending, (state) => {
        state.status = 'loading';
      })
      .addCase(fetchPublicOfficialById.fulfilled, (state, action) => {
        state.status = 'succeeded';
        state.current = action.payload ||[];
      })
      .addCase(fetchPublicOfficialById.rejected, (state, action) => {
        state.status = 'failed';
        state.error = action.payload || [];
      })
      .addCase(createPublicOfficial.pending, (state) => {
        state.createStatus = 'loading';
        state.createError = null;
      })
      .addCase(createPublicOfficial.fulfilled, (state, action) => {
        state.createStatus = 'succeeded';
        state.items.push(action.payload);
      })
      .addCase(createPublicOfficial.rejected, (state, action) => {
        state.createStatus = 'failed';
        state.createError = action.payload;
      })
      .addCase(updatePublicOfficial.pending, (state) => {
        state.updateStatus = 'loading';
        state.updateError = null;
      })
      .addCase(updatePublicOfficial.fulfilled, (state, action) => {
        state.updateStatus = 'succeeded';
        const idx = state.items.findIndex(o => o.id === action.payload.id);
        if (idx !== -1) state.items[idx] = action.payload;
      })
      .addCase(updatePublicOfficial.rejected, (state, action) => {
        state.updateStatus = 'failed';
        state.updateError = action.payload;
      })
      .addCase(deletePublicOfficial.pending, (state) => {
        state.deleteStatus = 'loading';
        state.deleteError = null;
      })
      .addCase(deletePublicOfficial.fulfilled, (state, action) => {
        state.deleteStatus = 'succeeded';
        state.items = state.items.filter(o => o.id !== action.payload);
      })
      .addCase(deletePublicOfficial.rejected, (state, action) => {
        state.deleteStatus = 'failed';
        state.deleteError = action.payload;
      });
  },
});

export default publicOfficialsSlice.reducer; 